//@vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');

//@commons
const { formatText } = require('core/i18n').i18n;
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');

// @ utilities
const { isDisasterRecoveryMode } = require('utilities/contactCenter/disasterRecoveryhelper');

class SendN2PasswordSuccessStep extends React.Component {
    constructor(props) {
        super(props);
        this.handleEndInteraction = this.handleEndInteraction.bind(this);
        this.handleRecoveryPasswordN2USD = this.handleRecoveryPasswordN2USD.bind(this);
    }

    handleEndInteraction() {
        this.props.history.push(`/disasterRecovery/customerFinder`);
    }

    handleRecoveryPasswordN2USD() {
        const { history, onGoBack } = this.props;

        onGoBack();
        history.push(`/myprofile/global`);
    }

    render() {
        const title = formatText('wizardSuccessSignature-successTitle');
        const subTitle = formatText('wizardSuccessSignature-successSubTitle');
        const textLink = formatText('addImposition-disasterRecoveryConfirmationBackbtn');
        const USDText = formatText('cc_stepClientLogin-optionGoToGlobalPosition');

        return (
            <article className="card-activator-success">
                <CustomMessageBox
                    icon="icon-success"
                    title={title}
                    subtitle={subTitle}
                    textLink={isDisasterRecoveryMode() ? textLink : USDText}
                    goBackHandler={isDisasterRecoveryMode() ? this.handleEndInteraction : this.handleRecoveryPasswordN2USD}
                />
            </article>
        );
    }
}

SendN2PasswordSuccessStep.propTypes = {
    history: PropTypes.object.isRequired,
    onGoBack: PropTypes.func,
};

module.exports = withRouter(SendN2PasswordSuccessStep);
